<div class="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl sm:p-6">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">{{ title }}</h2>
      <p class="mt-1 text-sm text-slate-500">
        Places where this variable is referenced.
      </p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  <ul class="mt-4 flex max-h-72 flex-col gap-2 overflow-y-auto">
    @for (usage of usages; track usage.targetPath + usage.formVersionId) {
      <li
        class="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm leading-5 text-slate-700">
        {{ usageLabel(usage) }}
      </li>
    } @empty {
      <li class="text-sm text-slate-500">Not used in any forms</li>
    }
  </ul>

  <div class="mt-5 flex justify-end">
    <lib-signal-button
      appearance="outline"
      [fullWidth]="false"
      (clicked)="close()">
      Close
    </lib-signal-button>
  </div>
</div>
